export const HISTORY_SMOKING_DYING_REQUEST = "HISTORY_SMOKING_DYING_REQUEST";
export const HISTORY_SMOKING_DYING_SUCCESS = "HISTORY_SMOKING_DYING_SUCCESS";
export const HISTORY_SMOKING_DYING_FAILED = "HISTORY_SMOKING_DYING_FAILED";
